import ks from "../ReUsableTS/kBrowserShared";
import { kStyles } from "../ReUsableTS/kStyles";
import { khtmlButton, kHTMLRow, kHTMLTable } from "../ReUsableTS/kHTML";
import LNG from "../ReUsableTS/kLNG";
import { kPhrase } from "../ReUsableTS/kPhrase";
import { kMultiSelectOption, kMultiSelectOptionType, kNaturalStringCompare, kMultiSelectOptionCompare } from "../ReUsableTS/kMultiSelectOption";
import { kHTMLMultiSelectCss } from "./kHTMLMultiSelectStyles";
import { kHTMLMultiSelectTopLayer } from "./kHTMLMultiSelectTopLayer";
import { kHTMLMultiSelectChrome } from "./kHTMLMultiSelectChrome";
export { kHTMLMultiSelectTopLayer } from "./kHTMLMultiSelectTopLayer";
export { kHTMLMultiSelectChrome } from "./kHTMLMultiSelectChrome";
export { kMultiSelectOption, kMultiSelectOptionType } from "../ReUsableTS/kMultiSelectOption";

export class kHTMLMultiSelect {
    public Search = true;

    public Height = "15rem";
    public Width = "100%";
    public Placeholder: string = LNG.SELECT;
    public Choices: string[] = [];
    public ChoiceOptions: kMultiSelectOption[] = [];
    public ListWrapper: HTMLDivElement | null = null;
    public SearchInput: HTMLInputElement | null = null;
    public AllOption: kMultiSelectOption | null = null;
    public OuterDiv: HTMLDivElement = document.createElement("div");
    public OKButton: khtmlButton = new khtmlButton();
    public ChangeCB: ((Selected: string[]) => void) | null = null;
    public OKClickCB: (() => void) | null = null;
    public AllSelected:boolean = false;
    public NoneSelectedOptionText: string = "";
    public ShowAllOption: boolean = false;
    // When true, a "+ Add new" row is rendered at the foot of the option list.
    // Clicking it fires OnAddNewRequested; the consumer captures a name and hands
    // it back via AddAndSelectChoice, which adds the option, checks it, and commits.
    // Default false keeps every existing caller unchanged.
    public AllowAddNew: boolean = false;
    public OnAddNewRequested: (() => void) | null = null;
    /**
     * Render the open panel in the browser's TOP LAYER instead of in normal flow.
     *
     * ⚠ THIS IS THE ONLY MECHANISM THAT RELIABLY KEEPS THE LIST VISIBLE, and the two obvious
     * alternatives were MEASURED to fail on a host that does what real dashboards do:
     *   - a bigger z-index does nothing once an ancestor creates a STACKING CONTEXT (a transform,
     *     a filter, a backdrop-filter, opacity < 1, will-change, contain:paint). z-index only
     *     orders siblings WITHIN one context, so 100 and 2147483647 lose identically.
     *   - position:fixed does not escape either: a transform/filter/backdrop-filter ancestor
     *     becomes the CONTAINING BLOCK for fixed descendants, so the panel is still positioned
     *     and clipped inside it.
     * The top layer sits above the whole document regardless of both, and is not clipped by any
     * ancestor's overflow. Measured on the harness's hostile host: 2 of 8 probe points visible
     * before, 8 of 8 after.
     *
     * The element does NOT move in the DOM - `popover` promotes it in place - so every
     * `:scope >` selector, event listener and ListWrapper reference keeps working.
     *
     * Default true. Set false to keep the pre-2026-08-16 in-flow panel; the control also falls
     * back to that on its own when the browser has no Popover API.
     */
    public UseTopLayer: boolean = true;
    /** Search row, Clear link, All row, choice row and OK button builders (kHTMLMultiSelectChrome). */
    private _Chrome: kHTMLMultiSelectChrome = new kHTMLMultiSelectChrome(this);
    /** Top-layer promotion of the open panel; owns the in-top-layer flag (kHTMLMultiSelectTopLayer). */
    private _TopLayer: kHTMLMultiSelectTopLayer = new kHTMLMultiSelectTopLayer(this);
    private _AddNewRow: HTMLDivElement | null = null;
    private _PlaceholderSpan: HTMLSpanElement | null = null;

    /**
     * Show `Placeholder` in the closed control when nothing is selected, and take it away the
     * moment a pill appears.
     *
     * Until 2026-08-14 `Placeholder` was DEAD — declared, defaulted to LNG.SELECT, documented in
     * the `building-multiselect` skill, and never read once. The `span.placeholder` rule has been
     * sitting in this file's own stylesheet the whole time with nothing ever carrying the class,
     * and the markup that used to append it is the commented-out original at the foot of the file.
     * An empty control therefore rendered as a bare box with a caret and no clue what it was for.
     *
     * Called from every path that adds or removes a pill rather than from a single place, because
     * pills are appended by kMultiSelectOption (SelectChoice) and by this class (SelectAll,
     * OKClick) and removed by three more — there is no one seam they all pass through.
     *
     * A consumer that sets `NoneSelectedOptionText` never reaches the empty state (DeSelectAll
     * substitutes that pill instead), so this is invisible to them.
     */
    public RefreshPlaceholder = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            const HasPill: boolean = this.OuterDiv.querySelector(":scope > span.optext") !== null;
            if (HasPill === true || this.Placeholder === "") {
                if (this._PlaceholderSpan !== null) {
                    this._PlaceholderSpan.remove();
                    this._PlaceholderSpan = null;
                }
                return;
            }
            if (this._PlaceholderSpan === null) {
                this._PlaceholderSpan = document.createElement("span");
                this._PlaceholderSpan.className = "placeholder";
            }
            this._PlaceholderSpan.textContent = this.Placeholder;
            this.OuterDiv.appendChild(this._PlaceholderSpan);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.RefreshPlaceholder");
        }
    };

    public AddStyles = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            kStyles.AddStyles("kHTMLMultiSelectStyles", kHTMLMultiSelect._Css);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.AddStyles");
        }
    };

    /** The control's stylesheet, injected once per page by `AddStyles`. A static PROPERTY
        rather than part of the method so the 40-line method rule measures LOGIC, not CSS. */
    private static _Css: string = kHTMLMultiSelectCss;

    public CountNormalUnSelected = (): number => {
        if (ks.KErrorMode === true) {
            return 0;
        }
        try {
            let NormalsUnSelected:number = 0;
            for(const CurrChoice of this.ChoiceOptions){
                if(CurrChoice.OptionType === kMultiSelectOptionType.Normal){
                    if(CurrChoice.OptInput){
                        if(CurrChoice.OptInput.checked ===false){
                            NormalsUnSelected++;
                        }
                    }
                }
            }
            return NormalsUnSelected;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.CountNormalUnSelected");
            return 0;
        }
    };
    public DeSelectUniques = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            if (this.ChoiceOptions) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.OptionType === kMultiSelectOptionType.Unique === true && Choice.Visible === true) {
                        if(Choice.OptInput){
                            if(Choice.OptInput.checked === true){
                                Choice.DeSelectChoice();
                            }
                        }
                    }
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.DeSelectUniques");
            return;
        }
    };
    /** Ticks every VISIBLE normal choice and unticks the Unique ones (a "unique" choice is by
        definition mutually exclusive with the rest, so "all" cannot include it).
        Returns true when at least one choice was FILTERED OUT — the caller uses that to decide
        whether "all" is honestly true. */
    private TickEveryVisibleChoice = (): boolean => {
        if (ks.KErrorMode === true) { return true; }
        try {
            let HiddenOptionsExist: boolean = false;
            if (!this.ChoiceOptions) { return false; }
            for (const Choice of this.ChoiceOptions) {
                if (Choice.Visible !== true) {
                    HiddenOptionsExist = true;
                    continue;
                }
                if (Choice.OptionType !== kMultiSelectOptionType.Unique) {
                    if (Choice.OptInput) { Choice.OptInput.checked = true; }
                    continue;
                }
                Choice.DeSelectChoice();
                if (Choice.OptInput) { Choice.OptInput.checked = false; }
            }
            return HiddenOptionsExist;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.TickEveryVisibleChoice");
            return true;
        }
    };

    public SelectAll = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            let HiddenOptionsExist = this.TickEveryVisibleChoice();
            if(HiddenOptionsExist === true){
                if(this.CountNormalUnSelected() === 0){
                    HiddenOptionsExist= false;
                }
            }
            if(HiddenOptionsExist === false){
                if(this.AllOption){
                    if(this.AllOption.OptInput){
                        this.AllOption.OptInput.checked = true;
                    }
                    this.OuterDiv.appendChild(this.AllOption.ToSelectedOption());
                }
                this.AllSelected = true;
            }else{
                this.AllSelected = false;
                if(this.AllOption){
                    this.AllOption.DeSelectChoice();
                }
            }
            this.RefreshPlaceholder();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.SelectAll");
            return;
        }
    };
    // REMOVED 2026-08-06: `uncheckAll` / `checkAll` were camelCase aliases that simply called
    // DeSelectAll / SelectAll. An import-graph scan over all 526 files that can see this module
    // found NO caller for either, so they were renamed out rather than kept as dead API.
    // Use DeSelectAll() / SelectAll().
    public SelectedChoices = (): string[] => {
        if (ks.KErrorMode === true) {
            return [];
        }
        try {
            const ReturnArray: string[] = [];
            for (const Choice of this.ChoiceOptions) {
                if(Choice.OptInput){
                    if (Choice.OptInput.checked === true) {
                        ReturnArray.push(Choice.Text);
                    }
                }
            }
            return ReturnArray;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.SelectedChoices");
            return [];
        }
    };
    public DeSelectAll = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            if (this.ChoiceOptions) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.Visible === true) {
                        Choice.DeSelectChoice();
                    }
                }
            }
            if(this.AllOption){
                this.AllOption.DeSelectChoice();
            }
            this.AllSelected = false;
            if(this.NoneSelectedOptionText !== ""){
                this.SetSelectedChoices([this.NoneSelectedOptionText]);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.DeSelectAll");
            return;
        }
    };

    public DocumentClick = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                // Demote BEFORE hiding. hidePopover() on an element already display:none still
                // works, but leaving the popover attribute set would keep the panel in the top
                // layer and keep the scroll/resize listeners alive for a closed control.
                this.HideFromTopLayer();
                this.ListWrapper.style.display = "none";
                document.removeEventListener("click", this.DocumentClick);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.DocumentClick");
        }
    };
    public SetSelectedChoices = (NewSelections: string[]): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            let CurrSelection = "";
            let NoneCaption:string = "";
            if (this.SearchInput) {
                this.SearchInput.textContent = "";
            }
            this.SearchInputChanged();
            if(NewSelections.length>0 && this.NoneSelectedOptionText !== ""){
                NoneCaption = this.NoneSelectedOptionText;
                this.NoneSelectedOptionText = "";
                this.DeSelectAll();
                this.NoneSelectedOptionText = NoneCaption; 
            }else{
                this.DeSelectAll();
            }
            for (CurrSelection of NewSelections) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.Text === CurrSelection) {
                        Choice.SelectChoice();
                    }
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.SetSelectedChoices");
            return;
        }
    };
    /** Search box, plus the "× Clear" link that sits on the same row (BuildClearLink). */
    private BuildSearchRow = (): void => {
        this._Chrome.BuildSearchRow();
    };
    private BuildClearLink = (): void => {
        this._Chrome.BuildClearLink();
    };
    private BuildAllOption = (): void => {
        this._Chrome.BuildAllOption();
    };

    private _AppendChoiceRow = (Text: string, Ref: HTMLElement | null, Label: string): kMultiSelectOption => {
        return this._Chrome.AppendChoiceRow(Text, Ref, Label);
    };

    /** Rows come from EITHER a plain `Choices` string list OR pre-built `ChoiceOptions`, never
        both — a caller supplying strings gets options built here; one supplying rich options
        (with icons, Unique types) keeps them. Both paths sort, so the list always reads in order. */
    private BuildChoiceRows = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if (this.ListWrapper === null) { return; }   // see BuildSearchRow
            if (this.Choices.length === 0) {
                this.ChoiceOptions.sort(kMultiSelectOptionCompare);
                for (const Option of this.ChoiceOptions) {
                    const ExistingDiv: HTMLDivElement | null = Option.ToAvailableOption();
                    if (ExistingDiv) { this.ListWrapper.appendChild(ExistingDiv); }
                    Option.Parent = this;
                }
                return;
            }
            this.Choices.sort(kNaturalStringCompare);
            for (const CurrentValue of this.Choices) {
                const NewMultiSelectOption: kMultiSelectOption = this._AppendChoiceRow(CurrentValue, null, "kHTMLMultiSelect.BuildChoiceRows");
                this.ChoiceOptions.push(NewMultiSelectOption);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.BuildChoiceRows");
        }
    };

    private BuildAddNewRow = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if (this.AllowAddNew !== true) { return; }
            if (this.ListWrapper === null) { return; }   // see BuildSearchRow
            this._AddNewRow = document.createElement("div");
            this._AddNewRow.className = "multiselect-dropdown-addnew";
            this._AddNewRow.textContent = "+ " + LNG.ADDNEW;
            this._AddNewRow.style.cursor = "pointer";
            this._AddNewRow.style.color = "#7B61FF";
            this._AddNewRow.style.fontWeight = "600";
            this._AddNewRow.style.padding = "6px 8px";
            this._AddNewRow.style.borderTop = "1px solid #E2E5EC";
            this._AddNewRow.style.marginTop = "4px";
            this._AddNewRow.addEventListener("click", this._AddNewClick);
            this.ListWrapper.appendChild(this._AddNewRow);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.BuildAddNewRow");
        }
    };

    private BuildOkButton = (): void => {
        this._Chrome.BuildOkButton();
    };

    public ToDiv = (): HTMLDivElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("div");
        }
        try {
            this.AddStyles();

            this.OuterDiv = document.createElement("div");
            this.OuterDiv.classList.add("multiselect-dropdown");
            this.OuterDiv.style.width = this.Width;

            this.ListWrapper = document.createElement("div");
            this.ListWrapper.className = "multiselect-dropdown-list-wrapper";

            this.BuildSearchRow();
            this.BuildAllOption();
            this.BuildChoiceRows();
            this.BuildAddNewRow();

            this.OuterDiv.appendChild(this.ListWrapper);
            this.OuterDiv.addEventListener("click", this.DivClick);

            this.BuildOkButton();
            this.RefreshPlaceholder();
            return this.OuterDiv;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.ToDiv");
            return document.createElement("div");
        }
    };
    /**
     * Update the available choices after the component has been rendered.
     * Preserves selections that still exist in the new choices.
     * @param NewChoices The new list of choice strings
     */
    /** Takes every rendered choice back off the page and forgets it. */
    private ClearRenderedChoices = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            for (const Opt of this.ChoiceOptions) {
                if (Opt.AvailableDiv !== null) { Opt.AvailableDiv.remove(); }
                if (Opt.SelectedOptionSpan !== null) { Opt.SelectedOptionSpan.remove(); }
            }
            this.ChoiceOptions = [];
            this.AllSelected = false;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.ClearRenderedChoices");
        }
    };

    /** Draws one row per choice, BEFORE the OK button so the button stays at the bottom. */
    private RenderChoiceRows = (NewChoices: string[]): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if (this.ListWrapper === null) { return; }
            const OKBtn: HTMLElement | null = this.ListWrapper.querySelector("button");
            for (const ChoiceText of NewChoices) {
                const NewOpt: kMultiSelectOption = this._AppendChoiceRow(ChoiceText, OKBtn, "kHTMLMultiSelect.RenderChoiceRows");
                this.ChoiceOptions.push(NewOpt);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.RenderChoiceRows");
        }
    };

    public SetChoices = (NewChoices: string[]): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            const PrevSelected: string[] = this.SelectedChoices();

            if (this.ListWrapper === null) { return; }

            this.ClearRenderedChoices();

            NewChoices.sort();
            this.Choices = NewChoices;
            this.RenderChoiceRows(NewChoices);

            const StillValid: string[] = [];
            const NewSet: Set<string> = new Set(NewChoices);
            for (const Prev of PrevSelected) {
                if (NewSet.has(Prev)) { StillValid.push(Prev); }
            }
            if (StillValid.length > 0) {
                this.SetSelectedChoices(StillValid);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.SetChoices");
        }
    };

    public SearchInputChanged = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                const SearchValue: string =
                    this.SearchInput.value.toUpperCase();
                for (const Choice of this.ChoiceOptions) {
                    if (
                        Choice.Text.toUpperCase().indexOf(SearchValue) > -1 ||
                        SearchValue === ""
                    ) {
                        if (Choice.AvailableDiv) {
                            Choice.AvailableDiv.style.display = "block";
                            Choice.Visible = true;
                        }
                    } else {
                        if (Choice.AvailableDiv) {
                            Choice.AvailableDiv.style.display = "none";
                            Choice.Visible = false;
                        }
                    }
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.SearchInputChanged");
        }
    };
    public OKClick = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            for (const Choice of this.ChoiceOptions) {
                if (Choice.SelectedOptionSpan) {
                    Choice.SelectedOptionSpan.remove();
                    Choice.SelectedOptionSpan = null;
                }
            }
            if(this.AllSelected ===false){
                for (const Choice of this.ChoiceOptions) {
                    if(Choice.OptInput && Choice.OptInput.checked === true){
                        this.OuterDiv.appendChild(Choice.ToSelectedOption());
                    }
                }
            }
            this.RefreshPlaceholder();
            this.DocumentClick();
            if (this.OKClickCB) { this.OKClickCB(); }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.OKClick");
        }
    };
    public DivClick = (Event: MouseEvent): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            this.ExpandListWrapper();
            Event.preventDefault();
            Event.stopPropagation();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.DivClick");
        }
    };
    private _CanUseTopLayer = (): boolean => {
        return this._TopLayer.CanUseTopLayer();
    };
    private _PositionPanel = (): void => {
        this._TopLayer.PositionPanel();
    };
    private _OnHostReflow = (): void => {
        this._TopLayer.OnHostReflow();
    };
    public ExpandListWrapper = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                this.ListWrapper.style.display = "block";
                this.ShowInTopLayer();
                this.SearchInput.focus();
                this.SearchInput.select();
                document.addEventListener("click", this.DocumentClick);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.ExpandListWrapper");
        }
    };
    /** Promote the open panel and start tracking the host. No-op when unsupported or opted out. */
    public ShowInTopLayer = (): void => {
        this._TopLayer.Show();
    };
    /** Demote the panel and stop tracking. Safe to call when it was never promoted. */
    public HideFromTopLayer = (): void => {
        this._TopLayer.Hide();
    };
    // The AvailableDiv of the first existing option that sorts AFTER Name, or null
    // when Name belongs at the end. ChoiceOptions is kept sorted, so the first
    // greater entry is the correct alphabetical insertion point for a new option.
    private _SortedInsertRef = (Name: string): HTMLElement | null => {
        if (ks.KErrorMode === true) {
            return null;
        }
        try {
            for (const Opt of this.ChoiceOptions) {
                if (Opt.AvailableDiv !== null && kNaturalStringCompare(Opt.Text, Name) > 0) {
                    return Opt.AvailableDiv;
                }
            }
            return null;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect._SortedInsertRef");
            return null;
        }
    };
    private _AddNewClick = (Event: MouseEvent): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            Event.preventDefault();
            Event.stopPropagation();
            if (this.OnAddNewRequested !== null) {
                this.OnAddNewRequested();
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect._AddNewClick");
        }
    };
    // Add a brand-new choice (if not already present), check it, and commit the
    // selection through OKClickCB — the same commit path RemoveClick uses. Called
    // by the consumer once it has captured the new name (see OnAddNewRequested).
    public AddAndSelectChoice = (NewChoice: string): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            const Name: string = ks.Nz(NewChoice).trim();
            if (Name === "") { return; }
            let Existing: kMultiSelectOption | null = null;
            for (const Opt of this.ChoiceOptions) {
                if (Opt.Text === Name) { Existing = Opt; break; }
            }
            if (Existing === null) {
                Existing = this._CreateAndInsertChoice(Name);
            }
            Existing.SelectChoice();
            if (this.ChangeCB !== null) {
                this.ChangeCB(this.SelectedChoices());
            }
            if (this.OKClickCB !== null) {
                this.OKClickCB();
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect.AddAndSelectChoice");
        }
    };
    // Create a brand-new option for Name and insert its row in alphabetical
    // position (before the first later-sorting choice, else above the "+ Add new"
    // row / at the end), then register it in ChoiceOptions (and in Choices only
    // when Choices is the active render source — mirroring for a ChoiceOptions-
    // sourced control would flip that source on the next open and drop the rich
    // options). Returns the new option. Extracted from AddAndSelectChoice for the
    // 40-line limit; behaviour is unchanged.
    private _CreateAndInsertChoice = (Name: string): kMultiSelectOption => {
        if (ks.KErrorMode === true) { return new kMultiSelectOption(); }
        try {
            const Ref: HTMLElement | null = this._SortedInsertRef(Name);
            let InsertBefore: HTMLElement | null = this._AddNewRow;
            if (Ref !== null) { InsertBefore = Ref; }
            const NewOpt: kMultiSelectOption = this._AppendChoiceRow(Name, InsertBefore, "kHTMLMultiSelect._CreateAndInsertChoice");
            this.ChoiceOptions.push(NewOpt);
            this.ChoiceOptions.sort(kMultiSelectOptionCompare);
            if (this.Choices.length > 0) {
                this.Choices.push(Name);
                this.Choices.sort(kNaturalStringCompare);
            }
            return NewOpt;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLMultiSelect._CreateAndInsertChoice");
            return new kMultiSelectOption();
        }
    };
}

//https://admirhodzic.github.io/multiselect-dropdown/demo.html

//           function newEl(tag,attrs){
//             var e=document.createElement(tag);
//             if(attrs!==undefined) Object.keys(attrs).forEach(k=>{
//               if(k==='class') { Array.isArray(attrs[k]) ? attrs[k].forEach(o=>o!==''?e.classList.add(o):0) : (attrs[k]!==''?e.classList.add(attrs[k]):0)}
//               else if(k==='style'){
//                 Object.keys(attrs[k]).forEach(ks=>{
//                   e.style[ks]=attrs[k][ks];
//                 });
//                }
//               else if(k==='text'){attrs[k]===''?e.innerHTML='&nbsp;':e.innerText=attrs[k]}
//               else e[k]=attrs[k];
//             });
//             return e;
//           }

//           document.querySelectorAll("select[multiple]").forEach((el,k)=>{

//             var div=newEl('div',{class:'multiselect-dropdown',style:{width:config.style?.width??el.clientWidth+'px',padding:config.style?.padding??''}});
//             el.style.display='none';
//             el.parentNode.insertBefore(div,el.nextSibling);
//             var listWrap=newEl('div',{class:'multiselect-dropdown-list-wrapper'});
//             var list=newEl('div',{class:'multiselect-dropdown-list',style:{height:config.height}});
//             var search=newEl('input',{class:['multiselect-dropdown-search'].concat([config.searchInput?.class??'form-control']),style:{width:'100%',display:el.attributes['multiselect-search']?.value==='true'?'block':'none'},placeholder:config.txtSearch});
//             listWrap.appendChild(search);
//             div.appendChild(listWrap);
//             listWrap.appendChild(list);

//             el.loadOptions=()=>{
//               list.innerHTML='';

//               if(el.attributes['multiselect-select-all']?.value=='true'){
//                 var op=newEl('div',{class:'multiselect-dropdown-all-selector'})
//                 var ic=newEl('input',{type:'checkbox'});
//                 op.appendChild(ic);
//                 op.appendChild(newEl('label',{text:config.txtAll}));

//                 op.addEventListener('click',()=>{
//                   op.classList.toggle('checked');
//                   op.querySelector("input").checked=!op.querySelector("input").checked;

//                   var ch=op.querySelector("input").checked;
//                   list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")
//                     .forEach(i=>{if(i.style.display!=='none'){i.querySelector("input").checked=ch; i.optEl.selected=ch}});

//                   el.dispatchEvent(new Event('change'));
//                 });
//                 ic.addEventListener('click',(ev)=>{
//                   ic.checked=!ic.checked;
//                 });
//                 el.addEventListener('change', (ev)=>{
//                   let itms=Array.from(list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")).filter(e=>e.style.display!=='none')
//                   let existsNotSelected=itms.find(i=>!i.querySelector("input").checked);
//                   if(ic.checked && existsNotSelected) ic.checked=false;
//                   else if(ic.checked==false && existsNotSelected===undefined) ic.checked=true;
//                 });

//                 list.appendChild(op);
//               }

//               Array.from(el.options).map(o=>{
//                 var op=newEl('div',{class:o.selected?'checked':'',optEl:o})
//                 var ic=newEl('input',{type:'checkbox',checked:o.selected});
//                 op.appendChild(ic);
//                 op.appendChild(newEl('label',{text:o.text}));

//                 op.addEventListener('click',()=>{
//                   op.classList.toggle('checked');
//                   op.querySelector("input").checked=!op.querySelector("input").checked;
//                   op.optEl.selected=!!!op.optEl.selected;
//                   el.dispatchEvent(new Event('change'));
//                 });
//                 ic.addEventListener('click',(ev)=>{
//                   ic.checked=!ic.checked;
//                 });
//                 o.listitemEl=op;
//                 list.appendChild(op);
//               });
//               div.listEl=listWrap;

//               div.refresh=()=>{
//                 div.querySelectorAll('span.optext, span.placeholder').forEach(t=>div.removeChild(t));
//                 var sels=Array.from(el.selectedOptions);
//                 if(sels.length>(el.attributes['multiselect-max-items']?.value??5)){
//                   div.appendChild(newEl('span',{class:['optext','maxselected'],text:sels.length+' '+config.txtSelected}));
//                 }
//                 else{
//                   sels.map(x=>{
//                     var c=newEl('span',{class:'optext',text:x.text, srcOption: x});
//                     if((el.attributes['multiselect-hide-x']?.value !== 'true'))
//                       c.appendChild(newEl('span',{class:'optdel',text:'🗙',title:config.txtRemove, onclick:(ev)=>{c.srcOption.listitemEl.dispatchEvent(new Event('click'));div.refresh();ev.stopPropagation();}}));

//                     div.appendChild(c);
//                   });
//                 }
//                 if(0==el.selectedOptions.length) div.appendChild(newEl('span',{class:'placeholder',text:el.attributes['placeholder']?.value??config.placeholder}));
//               };
//               div.refresh();
//             }
//             el.loadOptions();

//             search.addEventListener('input',()=>{
//               list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach(d=>{
//                 var txt=d.querySelector("label").innerText.toUpperCase();
//                 d.style.display=txt.includes(search.value.toUpperCase())?'block':'none';
//               });
//             });

//             div.addEventListener('click',()=>{
//               div.listEl.style.display='block';
//               search.focus();
//               search.select();
//             });

//             document.addEventListener('click', function(event) {
//               if (!div.contains(event.target)) {
//                 listWrap.style.display='none';
//                 div.refresh();
//               }
//             });
//           });

//     }

// }
